export default __webpack_public_path__ + "static/media/inr.03a72796.svg";